import React, { useState, useMemo, useContext } from 'react';
import * as Util from './utilities.js';

function makeStore() {
  // Make a context for the store
  const context = React.createContext();

  // Make a provider that takes an initialValue
  const Provider = ({ initialValue, children }) => {
    let myInitialValue = initialValue;
    if (myInitialValue === undefined){
      //console.log('OMG initial value is undefined');
      myInitialValue = Util.getStoreInitialValue();
    }
    const [state, setState] = useState(myInitialValue);

    // Memoize the context value to update when the state does
    const contextValue = useMemo(() => [state, setState], [state]);

    // Provide the store to children
    return <context.Provider value={contextValue}>{children}</context.Provider>;
  };

  // A hook to help consume the store
  const useStore = () => useContext(context);

  return [Provider, useStore];
}

const [StoreProvider, useStore] = makeStore();

export {
  StoreProvider,
  useStore
};